/**
 * 统计-创作方
 */

import BaseAuthClient from './baseAuth';

class StatisticNorClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const statisticNorClient = new StatisticNorClient();

export default statisticNorClient;

// 数据总览
// 卡片数据
export const getCreationSummary = (option: any) =>
  statisticNorClient.get(`/v1/datastatistics/getcreationsummary`, option);

// 图表数据
export const getCreationChartData = (option: any) => statisticNorClient.get(`/v1/datastatistics/getchartdata`, option);
// 获取创作环节列表
export const getLinkList = (option: any) => statisticNorClient.get(`/v1/datastatistics/getlinklist`, option);

// 数据明细
// 任务情况明细
export const taskCycleDetail = (option: any) => statisticNorClient.get(`/v1/workbench/taskcycle`, option);
// 过审情况明细
export const retrialCycleDetail = (option: any) => statisticNorClient.get(`/v1/workbench/retrialcycle`, option);
// 逾期审批明细
export const overdueApproveDetail = (option: any) => statisticNorClient.get(`/v1/workbench/overdueapprove`, option);
// 逾期情况明细
export const overdueCycleDetail = (option: any) => statisticNorClient.get(`/v1/workbench/overduecycle`, option);
// 逾期提交明细
export const overdueSubDetail = (option: any) => statisticNorClient.get(`/v1/workbench/overduesub`, option);
// 目标情况明细
export const targetCycleDetail = (option: any) => statisticNorClient.get(`/v1/workbench/targetcycle`, option);
